export default __webpack_public_path__ + "static/EasyTipster_login-086a71e5a12cc445c34201c3becebf85.png";